import axios from 'axios'

export const getShiptos = companyId => {
    return axios.get('/ajax/company/shiptos?id=' + companyId)
}
